import AdvancedController from "./advanced-controller"
import { Breakpoints } from "../utils/breakpoints";

const NAV_TOGGLE_BREAKPOINT = 'md'

export default class HeaderController extends AdvancedController {

    static values = {
        isNavToggled: Boolean,
        isSearchToggled: Boolean,
    }

    static targets = [
        "navToggle",
        "searchForm",
        "searchField",
        "searchToggleButton"
    ]

    connect() {
        super.connect();

        // init a breakpoints manager for later queries
        this.breakpoints = new Breakpoints();

        this.navMainTarget = document.getElementById('nav-main');
        this.navMainTargetUl = this.navMainTarget.querySelector('ul');

        this.menuCtaContainerTarget = document.querySelector('.menu-cta-container');
        this.menuCtaBlockTarget = document.querySelector('.menu-cta');


        // outside click close
        window.addEventListener('click', (e) => {
            if (this.isSearchToggledValue && !this.searchFormTarget.contains(e.target) && !this.searchToggleButtonTarget.contains(e.target)) {
                this.isSearchToggledValue = false
                this._handleState();
            }
        })
        this.resize();
    }

    resize() {
        if (this.menuCtaContainerTarget && this.menuCtaBlockTarget) {        
            if (this.breakpoints.breakpointDown(NAV_TOGGLE_BREAKPOINT)) {
                this.menuCtaBlockTarget.classList.add('-moved-menu');
                this.navMainTargetUl.append(this.menuCtaBlockTarget);
            } else {
                if (this.menuCtaBlockTarget.classList.contains('-moved-menu')) {

                    this.menuCtaContainerTarget.append(this.navMainTargetUl.querySelector('.-moved-menu'));
                    this.menuCtaContainerTarget.children[0].classList.remove('-moved-menu');
                }
            }
        }
    }

    onToggleClick(e) {
        e.preventDefault();
        this.isNavToggledValue = !this.isNavToggledValue;
        if (this.isNavToggledValue) this.isSearchToggledValue = false
        this._handleState();
    }

    onSearchToggle(e) {
        e.preventDefault();
        this.isSearchToggledValue = !this.isSearchToggledValue;
        if (this.isSearchToggledValue) this.isNavToggledValue = false
        this._handleState();
    }

    _handleClasses() {
        this.element.classList.toggle('-nav-toggled', this.isNavToggledValue)
        this.element.classList.toggle('-search-toggled', this.isSearchToggledValue)
    }

    _handleState() {
        this._handleClasses();

        if (this.isNavToggledValue) {
            this.navMainTarget.style.display = "flex"
            document.body.style.overflowY = "hidden"
        } else {
            this.navMainTarget.style.display = "none"
            document.body.style.overflowY = "auto"
        }
        if (this.hasSearchFormTarget) {
            if (this.isSearchToggledValue) {
                this.searchFormTarget.style.display = "flex"
                this.searchFieldTarget.focus()
            } else {
                this.searchFormTarget.style.display = "none"
            }
        }
    }

    messageCloseNav() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageClose();
        }
        this.isNavToggledValue = false
        this._handleState();
    }

}